import { render, staticRenderFns } from "./modelSection.vue?vue&type=template&id=dc95708a&scoped=true&lang=pug"
import script from "./modelSection.vue?vue&type=script&lang=js"
export * from "./modelSection.vue?vue&type=script&lang=js"
import style0 from "@/CommonDP/mongeView/common/common.scss?vue&type=style&index=0&id=dc95708a&prod&lang=scss&scoped=true&external"
import style1 from "./modelSection.vue?vue&type=style&index=1&id=dc95708a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc95708a",
  null
  
)

export default component.exports